import React, {Component} from 'react'
import {DPart, Node, paperInfo} from "../../store/model";
import store from '../../store'
import _ from 'lodash'
import * as d3 from 'd3'

import {
    SetHalfSelectedEdgesAction,
    SetSelectedEdgesAction,
    SetSelectedPapersAction,
    SetYearsAction
} from "../../store/actions";
import {getRelatedPapersAndEdgesByNodes, getNodeListById, filterPapersBySelectedPapers} from "../../utils";

interface props {
    state: any
    setHalfSelectedEdges: (newState: Array<number>) => SetHalfSelectedEdgesAction;
    setSelectedEdges: (newState: Array<number>) => SetSelectedEdgesAction;
    setSelectedPapers: (newState: Array<number>) => SetSelectedPapersAction;
    setYears: (newState: Array<number>) => SetYearsAction;
    scale: number
    bh: number
    rightDis: number
}

interface state {
    selectedYears: number[]
}

const bg = [
    [
        2007,
        2
    ],
    [
        2008,
        0
    ],
    [
        2009,
        1
    ],
    [
        2010,
        3
    ],
    [
        2011,
        8
    ],
    [
        2012,
        4
    ],
    [
        2013,
        9
    ],
    [
        2014,
        12
    ],
    [
        2015,
        11
    ],
    [
        2016,
        12
    ],
    [
        2017,
        8
    ],
    [
        2018,
        11
    ],
    [
        2019,
        11
    ],
    [
        2020,
        14
    ],
    [
        2021,
        16
    ],
    [
        2022,
        1
    ]
]

class Papers extends Component<props, state> {
    constructor(props: any) {
        super(props);
        this.state = {selectedYears: []};
    }


    yearCount(Papers: paperInfo[], bg: number[][]) {
        let cur = bg
        for (let i = 0; i < bg.length; i++) {
            cur[i][1] = 0
            for (let j = 0; j < Papers.length; j++) {
                if (Papers[j].year === cur[i][0])
                    cur[i][1] += 1
            }
        }
        return cur
    }

    refresh_debounce = _.debounce(() => {
        this.setState({});
    }, 300)

    handleResize = () => {
        d3.select("#brush").remove()

        let brush = d3.brushX()
            .on("end", this.brushed)

        let elem = document.querySelector('#barChart');
        let rect
        if (elem) {
            rect = elem.getBoundingClientRect()
            d3.select("#barChart").append("g")
                .attr("class", "brush")
                .attr("id", "brush")
                .call(brush.extent([[0, 0], [rect.width, rect.height]]));
        }


    }

    brushed = (event: any) => {
        const selection = event.selection;
        if (selection === null) {
            for (let i = 0; i < bg.length; i++) {
                d3.select("#rect" + i).attr("fill", "#f9ca24")
                this.setState({selectedYears: []})
                this.props.setYears([])
                const {edges, edgesBG, papers} = getRelatedPapersAndEdgesByNodes(store.getState().NodesData.SelectedNodes);
                this.props.setHalfSelectedEdges(edgesBG);
                this.props.setSelectedEdges(edges)
                this.props.setSelectedPapers(papers);
            }
            return;
        }
        let elem = document.querySelector('#barChart');
        let rect, width
        if (elem) {
            rect = elem.getBoundingClientRect()
            width = rect.width
            const [x1, x2] = event.selection;
            const selectedYears = []
            for (let i = 0; i < bg.length; i++) {
                let left = i * width / bg.length
                let right = (i + 1) * width / bg.length
                let isBrushed = (right > x1 && left < x1) || (left < x2 && right > x1)
                if (isBrushed) {
                    selectedYears.push(i)
                }
            }
            this.props.setYears(selectedYears)
            const {edges, edgesBG, papers} = getRelatedPapersAndEdgesByNodes(store.getState().NodesData.SelectedNodes);
            this.props.setHalfSelectedEdges(edgesBG);
            this.props.setSelectedEdges(edges)
            this.props.setSelectedPapers(papers);
            this.setState({selectedYears: selectedYears})
        }
    }

    yearsIndex2act(yearData: number[][], index: number[]) {
        const years = []
        for (let i = 0; i < index.length; i++) {
            years.push(yearData[index[i]][0])
        }
        return years
    }

    async componentDidMount() {
        store.subscribe(() => {
            this.refresh_debounce()
        })

        // this.handleResize()
        window.addEventListener('resize', this.handleResize)
        // window.addEventListener('beforeunload', this.handleResize)

        let elem = document.querySelector('#barChart');
        let rect
        if (elem) {
            rect = elem.getBoundingClientRect();
        }
        let brush = d3.brushX()
            .on("end", this.brushed)
        if (rect) {
            d3.select("#barChart").append("g")
                .attr("class", "brush")
                .attr("id", "brush")
                .attr("width", rect.width)
                .attr("height", rect.height)
                .call(brush.extent([[0, 0], [921 * this.props.scale, 380 * this.props.scale]]));
        }

    }

    render() {
        const Papers: paperInfo[] = store.getState().Papers.Papers;
        const selectedPapers: number[] = store.getState().Papers.SelectedPapers;
        const D: DPart[] = store.getState().Division;
        let filteredPapers = filterPapersBySelectedPapers(Papers, selectedPapers);
        const yearData = this.yearCount(filteredPapers, bg)
        const {scale} = this.props;

        for (let i = 0; i < bg.length; i++) {
            yearData[i].push(bg[i][1])
        }

        let years: number[] = []
        if (this.state.selectedYears.length > 0) {
            years = this.yearsIndex2act(yearData, this.state.selectedYears)
            for (let i = 0; i < yearData.length; i++) {
                if (!years.includes(yearData[i][0])) {
                    yearData[i][1] = 0
                }
            }
        }


        return (
            <>
                <div className="barChartCon">
                    <div
                        style={
                            {
                                fontSize: scale * 30
                            }
                        }
                    >
                        {this.state.selectedYears.length > 0 ? this.state.selectedYears[0] + 2007 : 2007}
                        -
                        {this.state.selectedYears.length > 0 ? this.state.selectedYears[this.state.selectedYears.length - 1] + 2007 : 2022}
                    </div>
                    <div className="container"
                    >
                        <svg id="barChart" width="100%" height="100%">
                            {
                                yearData.map((d, index: number) => (
                                    <g key={index}>
                                        <rect
                                            x={index * 100 / (yearData.length) + "%"}
                                            y={100 - d[2] * 5 + "%"}
                                            height={d[2] * 5 + "%"}
                                            width={100 / (yearData.length) + "%"}
                                            fill="#dfe6e9"
                                            stroke="white"
                                            rx={5 * scale}
                                            ry={5 * scale}
                                            style={
                                                {
                                                    transition: "1s",
                                                }
                                            }
                                        />
                                        <rect
                                            id={"rect" + index}
                                            x={index * 100 / (yearData.length) + "%"}
                                            y={100 - d[1] * 5 + "%"}
                                            height={d[1] * 5 + "%"}
                                            width={100 / (yearData.length) + "%"}
                                            fill="#f9ca24"
                                            stroke="white"
                                            rx={5 * scale}
                                            ry={5 * scale}
                                            style={
                                                {
                                                    transition: "1s",
                                                }
                                            }
                                        />
                                    </g>
                                ))
                            }
                        </svg>
                    </div>
                </div>
                <div className="paperList">
                    {filteredPapers.map((d: paperInfo, index: number) => (
                        <div key={index}>
                            <div
                                className="TajawalText"
                                id={"paper" + index}
                                key={index}
                                style={
                                    {
                                        textAlign: "justify",
                                        fontSize: 15 * scale * 1.5,
                                        width: "100%",
                                        lineHeight: (1.4 - 0.3 * scale),
                                        paddingLeft: 10 * scale,
                                        paddingRight: 10 * scale,
                                        paddingTop: 20 * scale,
                                        paddingBottom: 20 * scale,
                                    }
                                }
                                color={'white'}
                                onMouseOver={function (e) {
                                    d3.select('#paper' + index)
                                        .style('background', '#87CEEB')
                                }}
                                onMouseOut={function (e) {
                                    d3.select('#paper' + index)
                                        .style('background', 'white')
                                }}
                            >
                                <div style={{
                                    paddingLeft: 20 * scale,
                                    paddingRight: 30 * scale
                                }}>{d.name}</div>
                                <div style={
                                    {
                                        marginTop: 10 * scale,
                                        paddingLeft: 20 * scale,
                                        paddingRight: 30 * scale
                                    }
                                }>
                                    {
                                        getNodeListById(d.nodeList)
                                            .map((l: Node, index: number) => (
                                                <span
                                                    key={index}
                                                    style={{
                                                        padding: '3px',
                                                        lineHeight: scale,
                                                    }}
                                                >
                                            <button
                                                className="TajawalText"
                                                style={
                                                    {
                                                        background: D[l.type - 1].color,
                                                        height: 20 * (2.2 - scale) * scale * 1.5,
                                                        borderRadius: 8 * scale,
                                                        outlineOffset: 3 * scale,
                                                        fontSize: 5 * scale * scale * 3,
                                                        border: 0,
                                                        marginTop: 3 * scale,
                                                        marginBottom: 3 * scale,
                                                        color: "white",
                                                        overflow: 'hidden',
                                                    }
                                                }>
                                                {l.name}
                                            </button>
                                        </span>
                                            ))
                                    }

                                </div>
                            </div>
                            <div
                                className="line"
                                style={
                                    {
                                        width: "95%",
                                        marginLeft: 20 * scale,
                                        paddingLeft: 10 * scale,
                                        paddingRight: 10 * scale,
                                        height: 1.5 * scale,
                                        backgroundColor: "#999999",
                                        flexGrow: 0.1
                                    }
                                }
                            />
                        </div>

                    ))}
                </div>
            </>
        )

    }
}


export default Papers;